import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Placeholder Rozyx Vision wordmark. Same interface as the deallock SVG logo it
 * replaces (scales via className); swap for the real brand asset when design lands.
 */
export default function Logo({ className }) {
    return (_jsx("svg", { viewBox: "0 0 328 61", fill: "none", xmlns: "http://www.w3.org/2000/svg", shapeRendering: "geometricPrecision", role: "img", "aria-label": "Rozyx Vision", className: className, children: _jsx("text", { x: "0", y: "46", fill: "#0a0a0a", fontFamily: "Inter, system-ui, sans-serif", fontSize: "44", fontWeight: "600", letterSpacing: "-1", children: "Rozyx Vision" }) }));
}
